import type { ReactElement } from 'react'

const ROW_COUNT = 3

/**
 * Stand-in for the first results of a search. Shaped like a Contacts group (heading,
 * then rows with a name line and a shorter detail line) so the modal holds its size
 * and the real rows land in place rather than pushing the layout around.
 */
export function PaletteSkeleton(): ReactElement {
  return (
    <div role="status" aria-label="Searching" className="animate-pulse px-3 pt-3 pb-2">
      <div className="mb-3 h-3 w-16 rounded bg-surface-muted" />
      {Array.from({ length: ROW_COUNT }, (_, i) => (
        <div key={i} className="flex items-center gap-3 px-2 py-2.5">
          <div className="h-8 w-8 shrink-0 rounded-full bg-surface-muted" />
          <div className="flex min-w-0 grow flex-col gap-1.5">
            <div className="h-3 w-2/5 rounded bg-surface-muted" />
            <div className="h-2.5 w-1/4 rounded bg-surface-muted" />
          </div>
        </div>
      ))}
    </div>
  )
}
